import React from "react";
import { ImageList } from "@mui/material";

const DSImageList = (props: React.ComponentProps<typeof ImageList>) => {
  return <ImageList {...props} />;
};

export default DSImageList;
